import { TimeFormat } from "../types";

/**
 * Converts hours and minutes to a formatted time string.
 *
 * @param hours - Hours (0-23)
 * @param minutes - Minutes (0-59)
 * @param format - Target format (12 or 24 hour)
 * @returns Formatted time string
 */
export function formatTimeString(
  hours: number,
  minutes: number,
  format: TimeFormat,
): string {
  // Handle 24:00 edge case
  if (hours === 24) {
    hours = 0; // Convert 24:00 to 00:00
  }

  if (format === 12) {
    // Convert to 12-hour format
    let displayHours = hours;
    let period = "AM";

    if (hours === 0) {
      displayHours = 12;
    } else if (hours > 12) {
      displayHours = hours - 12;
      period = "PM";
    } else if (hours === 12) {
      period = "PM";
    }

    return `${displayHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${period}`;
  } else {
    // 24-hour format
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  }
}
